var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWire(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.377,
    y1: -0.336,
    x2: 0.594,
    y2: 1.152,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff5e9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.605,
    stopColor: "#7d95e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999,
    stopColor: "#3f28dd"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Wire",
    transform: "translate(-181 -55)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6096",
    "data-name": "Rectangle 6096",
    width: 24,
    height: 24,
    transform: "translate(181 55)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1956",
    "data-name": "Path 1956",
    d: "M15.6,20.807H4.006A1.228,1.228,0,0,1,2.8,19.6V2.906A1.228,1.228,0,0,1,4.006,1.7H15.6a1.228,1.228,0,0,1,1.206,1.206V19.6A1.228,1.228,0,0,1,15.6,20.807Z",
    transform: "translate(181.064 55.7)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1957",
    "data-name": "Path 1957",
    d: "M9.629,4.378C8.516,5.77,7.4,7.161,6.29,8.645c-.278.371-.093.742.464.742.464,0,1.67-.093,1.67.093v5.194a.831.831,0,0,0,.835.835h.557l1.762-2.041V9.387h1.67c.557,0,.649-.371.371-.835C12.5,7.161,11.484,5.77,10.371,4.378,10.186,4.007,9.907,4.007,9.629,4.378Z",
    transform: "translate(180.82 55.526)",
    fill: "#18253e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3265",
    "data-name": "Group 3265",
    transform: "translate(190.264 64.728)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_188",
    "data-name": "Ellipse 188",
    cx: 5.936,
    cy: 5.936,
    rx: 5.936,
    ry: 5.936,
    fill: "#33eeb1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1958",
    "data-name": "Path 1958",
    d: "M16.546,14.5H13.671a.4.4,0,0,1-.371-.371.34.34,0,0,1,.371-.371h2.875c0-.093-.093-.186-.093-.278a1.4,1.4,0,0,0-1.3-.835H13.764a.7.7,0,0,1-.371-.186c-.186-.186,0-.557.278-.557h4.174a.34.34,0,0,1,.371.371.4.4,0,0,1-.371.371h-1.02a4.971,4.971,0,0,1,.464,1.02h.557a.424.424,0,0,1,.464.371.4.4,0,0,1-.371.371h-.557a2.252,2.252,0,0,1-2.69,1.762l.186.186c.742.742,1.484,1.391,2.226,2.133l.186.186a.414.414,0,0,1,0,.464.306.306,0,0,1-.464,0c-.093,0-.093-.093-.186-.093-1.02-.928-2.041-1.948-2.968-2.875-.186-.186-.278-.278-.186-.557.093-.186.278-.186.464-.186h1.391A1.117,1.117,0,0,0,16.546,14.5Z",
    transform: "translate(-9.961 -9.767)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWire);
export default __webpack_public_path__ + "static/media/wire.2039a45ce90f81e953f5fbc79899f6fb.svg";
export { ForwardRef as ReactComponent };